import { clsx } from "clsx";

import { useWindowProperty } from '../../../../utils/hooks/useWidnowProperty';
import styles from './SpecificationPanel.module.scss'
import { useShelvingStore, useStoreSystem } from "../../../../store";
import { useStoreRoom } from "../../../../store/useStoreRoom";
import shallow from "zustand/shallow";
import useSectionsBySide from "./hooks/useSectionsBySide";
import { SectionInterface, SectionNomenklature, TireRackItemI } from "../../../../store/types/store";
import { LineForSpecificationGeneral } from "./LineForSpecificationGeneral";
import { getGuide, getItem, getTireRackItems } from "./utils";

export type GetItemReturnArr = {
    name: string;
    count: number;
    price: number;
    totalPrice: number;
};


export const SpecificationGeneral = () => {
    const windowDebug = useWindowProperty("debug", false);

    const { sectionsNomenklatureBack, sectionsNomenklatureFront, sectionsNomenklatureLeft, sectionsNomenklatureRight } =
        useShelvingStore(
            (state) => ({
                getCurrentShelving: state.getCurrentShelving,
                shelvings: state.shelving,
                sectionsNomenklatureBack: state.shelving.back.sectionsNomenklature,
                sectionsNomenklatureFront: state.shelving.front.sectionsNomenklature,
                sectionsNomenklatureLeft: state.shelving.left.sectionsNomenklature,
                sectionsNomenklatureRight: state.shelving.right.sectionsNomenklature,
            }),
            shallow
        );

    const { tireRacks } = useStoreRoom(
        (state) => ({
            tireRacks: state.tireRacks,
        }),
        shallow
    );

    const sectionsNomenklature = [
        ...sectionsNomenklatureBack,
        ...sectionsNomenklatureFront,
        ...sectionsNomenklatureLeft,
        ...sectionsNomenklatureRight,
    ];
    const sectionsList = useSectionsBySide();

    const hasContent = sectionsNomenklature.length > 0 || sectionsList.length > 0 || tireRacks.length > 0;

    if (!hasContent) {
        return null;
    }

    const { returnItems, returnElements } =
        sectionsNomenklature.length > 0 && sectionsList.length > 0
            ? getItem(sectionsList)
            : { returnItems: [], returnElements: [] };

    const { returnGuideArr, connectors } =
        sectionsNomenklature.length > 0 ? getGuide(sectionsNomenklature) : { returnGuideArr: [], connectors: [] };

    const tireRackItems = getTireRackItems(tireRacks);

    return (
        <div
            className={clsx(
                styles.specificationGeneral_main,
                windowDebug && styles.specificationGeneral_main__windowDebug
            )}
        >
            <div className={styles.specificationGeneral_head}>Товар</div>
            <div className={styles.specificationGeneral_head}>Кол-во</div>
            {windowDebug && (
                <>
                    <div className={styles.specificationGeneral_head}>Цена</div>
                    <div className={styles.specificationGeneral_head}>Сумма</div>
                </>
            )}
            <LineForSpecificationGeneral arrLine={returnItems} windowDebug={windowDebug} />
            <LineForSpecificationGeneral arrLine={returnElements} windowDebug={windowDebug} />
            <LineForSpecificationGeneral arrLine={returnGuideArr} windowDebug={windowDebug} />
            <LineForSpecificationGeneral arrLine={connectors} windowDebug={windowDebug} />
            {tireRackItems.length > 0 && (
                <LineForSpecificationGeneral arrLine={tireRackItems} windowDebug={windowDebug} />
            )}
        </div>
    );
};